import {
    FAIL, LOAD, CHANGE_DATA_RANGE, CHANGE_SELECTION_STATUS, CHANGE_SELECTION_TECH, CHANGE_SELECTION_MODEL,
    URL_API, CHANGE_SELECTION_RANGE, CHANGE_CODE,
    CHANGE_SELECTION_SERIAL, LOAD_TICKETS, TOGGLE_MODAL, TOGGLE_MODAL_COMMENT, CHANGE_SELECTION_PRODUCER,
    TICKETS_UPDATE, TICKETS_FAILURE, TICKETS_REQUEST, TICKETS_SUCCESS, TICKET_CLEAR, TICKET_FAILURE, TICKET_REQUEST, TICKET_SUCCESS,
    TICKET_UPDATE, TICKETS_URL, TYPE_REQUEST, TYPE_FAILURE, TYPE_SUCCESS, MODEL_FAILURE, MODEL_REQUEST, MODEL_SUCCESS,
    COMMENTADD_SUCCESS, COMMENTADD_FAILURE, COMMENTADD_REQUEST, PRODUCER_FAILURE, PRODUCER_SUCCESS, PRODUCER_REQUEST, CLEAR_FILTERS

} from '../constants'
import { RSAA } from 'redux-api-middleware';
import { withAuth } from '../reducers'


export function ticketsHasErrored(bool) {
    return {
        type: LOAD_TICKETS + FAIL,
        hasErrored: bool
    };
}

export function ticketsIsLoading(bool) {
    return {
        type: LOAD_TICKETS + LOAD,
        isLoading: bool
    };
}

export function ticketsFetchDataSuccess(items) {
    return {
        type: TICKETS_SUCCESS,
        items
    };
}

export function ticketsUpdateDataSuccess(tickets) {
    return {
        type: TICKETS_UPDATE,
        tickets
    };
}

export function ticketsUrl(url) {
    return {
        type: TICKETS_URL,
        url: url
    }
}

export const itemsUpdateData = (url) => ({
    [RSAA]: {
        endpoint: `${url}`,
        method: 'GET',
        headers: withAuth({ 'Content-Type': 'application/json' }),
        types: [
            TICKETS_REQUEST, TICKETS_UPDATE, TICKETS_FAILURE
        ]
    }
})


export function itemsFetchData(url) {
    return {
        [RSAA]: {
            endpoint: `${url}`,
            method: 'GET',
            headers: withAuth({ 'Content-Type': 'application/json' }),
            types: [
                TICKETS_REQUEST, TICKETS_SUCCESS, TICKETS_FAILURE
            ]
        }

    }
}

/////////////////////////////////////////////////////////////

export function techIsLoading(bool) {
    return {
        type: TYPE_REQUEST,
        payload: bool
    }
}
export function techIsErorred(bool) {
    return {
        type: TYPE_FAILURE,
        payload: bool
    }
}
export function techFetchSuccess(items) {
    return {
        type: TYPE_SUCCESS,
        items: items
    }
}

export const typeTechnics = () => ({
    [RSAA]: {
        endpoint: `${URL_API}/equip-type/`,
        method: 'GET',
        headers: withAuth({ 'Content-Type': 'application/json' }),
        types: [
            TYPE_REQUEST, TYPE_SUCCESS, TYPE_FAILURE
        ]
    }
})

//////////////////////////////////////////////////////


export function modelFetchSuccess(items) {
    return {
        type: MODEL_SUCCESS,
        items: items
    }
}

export const modelTechnics = () => ({
    [RSAA]: {
        endpoint: `${URL_API}/equip-model/`,
        method: 'GET',
        headers: withAuth({ 'Content-Type': 'application/json' }),
        types: [
            MODEL_REQUEST, MODEL_SUCCESS, MODEL_FAILURE
        ]
    }
})



export const producerTechnics = () => ({
    [RSAA]: {
        endpoint: `${URL_API}/equip-producer/`,
        method: 'GET',
        headers: withAuth({ 'Content-Type': 'application/json' }),
        types: [
            PRODUCER_REQUEST, PRODUCER_SUCCESS, PRODUCER_FAILURE
        ]
    }
})

/////////////////////////////////////////////////////////////

export function ticketUpdateData(items) {
    return {
        type: TICKET_UPDATE,
        items
    }
}

export function ticketFetchDataSuccess(items) {
    return {
        type: TICKET_SUCCESS,
        items
    };
}

export const ticketItemData = (url) => ({
    [RSAA]: {
        endpoint: `${url}`,
        method: 'GET',
        headers: withAuth({ 'Content-Type': 'application/json' }),
        types: [
            TICKET_REQUEST, TICKET_SUCCESS, TICKET_FAILURE
        ]
    }
})

export function clearTicketData() {
    return {
        type: TICKET_CLEAR,
        ticket: ''
    }
}

// Modal

export function modalAction(bool) {
    return {
        type: TOGGLE_MODAL,
        isOpen: bool
    }
}
export function modalActionComments(bool) {
    return {
        type: TOGGLE_MODAL_COMMENT,
        isOpen: bool
    }
}

export const addComment = (jData) => ({
    [RSAA]: {
        endpoint: `${URL_API}/comment/`,
        method: 'POST',
        headers: withAuth({ 'Content-Type': 'application/json' }),
        body: JSON.stringify(jData),
        types: [
            COMMENTADD_REQUEST, COMMENTADD_SUCCESS, COMMENTADD_FAILURE
        ]
    }

})

// filters

export function changeDateRange(dateRange) {
    return {
        type: CHANGE_DATA_RANGE,
        payload: dateRange
    }
}
export function changeSelectStatus(selectStatus) {

    return {
        type: CHANGE_SELECTION_STATUS,
        payload: selectStatus
    }
}
export function changeSelectTech(selectTech) {
    return {
        type: CHANGE_SELECTION_TECH,
        payload: selectTech
    }
}

export function changeCode(code) {
    return {
        type: CHANGE_CODE,
        payload: code
    }
}

export function changeSelectModel(selectModel) {
    return {
        type: CHANGE_SELECTION_MODEL,
        payload: selectModel
    }
}


export function changeSelectProducer(selectProducer) {
    return {
        type: CHANGE_SELECTION_PRODUCER,
        payload: selectProducer
    }
}

export function changeCharSerial(charSerial) {
    return {
        type: CHANGE_SELECTION_SERIAL,
        payload: charSerial
    }
}

export function changeRangeTime(range) {
    return {
        type: CHANGE_SELECTION_RANGE,
        payload: range
    }
}
export function clearFilters() {
    return {
        type: CLEAR_FILTERS
    }
}


// WEBPACK FOOTER //
// ./src/actions/index.js